import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { AuthService } from 'src/app/core/services/auth.service';
import { ErrorHandlingService } from 'src/app/core/services/error-handling.service';
import { HttpService } from 'src/app/core/services/api/http.service';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { ValidationService } from 'src/app/core/services/validation.service';
import { ThirdPartiesApiService } from 'src/app/core/services/api/third-parties-api.service';
import { Observable, finalize, map, take } from 'rxjs';
import { ApiResponse } from '../../models/api-response.interface';
import {
  Contact,
  ThirdPartyFullObject,
} from '../../models/third-party.interface';
import { Product } from '../../models/product.interface';
import { UsersGroup } from '../../enums/users-group.enum';
import { Auto_Complete } from '../../../core/services/auto-complete';
import { InputFieldType } from '../../models/input-types.enum';
import { API_VERSIONS } from '../../consts/api-versions.const';
import { parseUSPhoneNumber } from '../../utils/parse-us-phone-number.util';

@Component({
  selector: 'app-clients-form',
  templateUrl: './clients-form.component.html',
  styleUrls: ['./clients-form.component.css'],
})
export class ClientsFormComponent implements OnInit {
  addUserForm!: FormGroup;
  addEditUserPopup: boolean = false;
  isAddNew: boolean = false;
  userId: number = 0;
  isLoadingOnboarding: boolean = false;
  onboardingList: any[] = [];
  loadingSubmit: boolean = false;
  // when canceling popup from outside of cancel button open discard popup
  @ViewChild('messageComponent', { static: false }) messageComponent: any;
  loadingConfirm: boolean = false;

  maxDate: any;

  selectedProducts: any = [];
  selectedProdIds: any;
  isLoadingTheProducts: boolean = false;
  allProducts: any;
  isChangeOrders: boolean = false;
  isLoading: boolean = false;
  isSubUserForm: boolean = false;

  clientsCreatedList: any;
  userObj = this._auth.getUserObj() || {};

  @Output('onAddEditDealer') onAddEditDealer =
    new EventEmitter<String | null>();
  @Input('whoEntered') whoEntered: {
    form: string;
    from: string;
    createdUsers: string;
  } = { form: 'Dealer', from: 'admin', createdUsers: 'Agents' };

  productFilter: Auto_Complete = new Auto_Complete(
    this._api,
    this.errHandle,
    `/${API_VERSIONS.PRODUCTS}/products`,
    true
  );
  parentFilter: Auto_Complete = new Auto_Complete(
    this._api,
    this.errHandle,
    `/${API_VERSIONS.USERS}/users`,
    true,
    false,
    true,
    'global_search'
  );
  clientsCreatedFilter: Auto_Complete = new Auto_Complete(
    this._api,
    this.errHandle,
    `/${API_VERSIONS.USERS}/users`,
    true,
    false,
    true,
    'search_by_third_party'
  );

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private validationService: ValidationService,
    private _api: HttpService,
    private _auth: AuthService,
    private notificationService: NotificationsService,
    private activatedRoute: ActivatedRoute,
    private errHandle: ErrorHandlingService,
    public _pService: PermissionsService
  ) {}

  ngOnInit(): void {
    this.productFilter.options = {
      ...this.productFilter.options,
      include_atlantic_products: true,
    };
    this.initForm();
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['openPopup']) {
        // this.addEditUserPopup = true;
        this.openAddEditPopup(true);
        this.loadFormValuesFromLocalStorage();
      } else {
        if (this._pService.hasListPermissions(['update_user', 'create_user'])) {
          this.getOnboarding();
        }
        if (this.whoEntered.from == 'admin') {
          this.getAllGroupsUsers();
        }
      }
    });
  }

  get contactsFormArray(): FormArray {
    return this.addUserForm.get('contacts') as FormArray;
  }

  get parent_id() {
    return this.addUserForm.get('parent_id');
  }
  get fname() {
    return this.addUserForm.get('fname');
  }
  get lname() {
    return this.addUserForm.get('lname');
  }
  get email() {
    return this.addUserForm.get('email');
  }
  get client_name() {
    return this.addUserForm.get('client_name');
  }
  get internal_code() {
    return this.addUserForm.get('internal_code');
  }
  get created_name() {
    return this.addUserForm.get('created_name');
  }

  get products() {
    return this.addUserForm.get('products');
  }

  addContact() {
    this.contactsFormArray.push(
      this.newContactForm(null, undefined, undefined)
    );
  }

  deleteContact(i: number): void {
    this.contactsFormArray?.removeAt(i);
  }

  newContactForm(id: number | null = null, email?: string, phone?: string) {
    const productForm = this.fb.group({
      id: [id],
      email: [
        email || '',
        Validators.pattern(this.validationService.emailPattern),
      ],
      mobile: [
        phone || '',
        Validators.pattern(this.validationService.validPhoneUS),
      ],
    });

    return productForm;
  }

  getAllGroupsUsers(): void {
    if (this.whoEntered.createdUsers === 'Agents') {
      this.clientsCreatedFilter.options = {
        filter_by_group: UsersGroup.Agents,
      };
    } else if (this.whoEntered.createdUsers === 'Brokers') {
      this.clientsCreatedFilter.options = {
        filter_by_group: UsersGroup.Brokers,
      };
    }
  }

  getUserGroupId() {
    switch (this.whoEntered.form) {
      case 'Agent': {
        return UsersGroup.Brokers;
      }
      case 'Dealer': {
        return UsersGroup.Agents;
      }
      default:
        return UsersGroup.Dealers;
    }
  }

  getParentGroupId() {
    switch (this.whoEntered.form) {
      case 'Agent': {
        return UsersGroup.Agents;
      }
      case 'Broker': {
        return UsersGroup.Brokers;
      }
      default:
        return UsersGroup.Dealers;
    }
  }

  saveDataInLocalStorage() {
    Object.keys(this.addUserForm.controls).forEach((key) => {
      const control = this.addUserForm.get(key);
      if (control?.value) {
        if (key === 'formArray') {
          let values = control?.value;
          values = values.filter((value: any) => value.check === true);
          if (values?.length > 0) {
            localStorage.setItem(key, JSON.stringify(values));
          }
        } else if (key === 'products') {
          if (control?.value?.length > 0) {
            localStorage.setItem(key, JSON.stringify(control?.value));
          }
        } else if (key === 'created_name') {
          if (control?.value) {
            localStorage.setItem(key, JSON.stringify(control?.value));
          }
        } else if (key === 'formAddress') {
          //
          if (control?.value?.street_address?.label) {
            localStorage.setItem(key, JSON.stringify(control?.value));
          }
        } else {
          localStorage.setItem(key, control?.value);
        }
        //
      }
    });
    this.router.navigate(
      [
        '/dashboard/clients/' +
          this.whoEntered.form.toLocaleLowerCase() +
          '/settings/onboarding-forms/add',
      ],
      { queryParams: { source: 'from-popup' } }
    );
  }

  loadFormValuesFromLocalStorage() {
    let isSelectOnboard = false;
    Object.keys(this.addUserForm.controls).forEach((key) => {
      const control: any = this.addUserForm.get(key);
      const storedValue = localStorage.getItem(key);
      if (storedValue) {
        if (key === 'products' || key === 'formAddress') {
          const parsedValue = JSON.parse(storedValue);
          if (parsedValue) {
            setTimeout(() => {
              control?.setValue(parsedValue);
            }, 0);
          }
        } else if (key === 'formArray') {
          const parsedValue = JSON.parse(storedValue);
          //
          isSelectOnboard = true;
          this.getOnboarding(parsedValue);
        } else {
          control?.setValue(storedValue);
        }
      }
    });
    if (!isSelectOnboard) {
      this.getOnboarding();
    }
    this.addUserForm.markAsUntouched();
  }

  clearFormValuesFromLocalStorage() {
    Object.keys(this.addUserForm.controls).forEach((key) => {
      localStorage.removeItem(key);
    });
  }
  //to handling looping on form arrays in html
  getFormsArray(form: any) {
    return form?.controls;
  }

  get formAddress(): FormGroup {
    return this.addUserForm.get('formAddress') as FormGroup;
  }

  getOnboarding(selectedForms?: any) {
    this.isLoadingOnboarding = true;
    this._api.getReq(`/onboard/${this.whoEntered.form}/form`).subscribe(
      (res) => {
        let formArray = this.addUserForm.get('formArray') as FormArray;
        formArray.clear();
        res?.data.forEach((onboard: any) => {
          const selectedForm = selectedForms?.find(
            (selectedItem: any) => selectedItem.onboardIngId === onboard.id
          );
          const initialCheckValue = selectedForm ? selectedForm.check : false;
          (formArray as FormArray).insert(
            0,
            new FormGroup({
              onboardIngId: new FormControl(onboard?.id, []),
              title: new FormControl(onboard?.title, []),
              check: new FormControl(initialCheckValue, []),
            })
          );
        });

        this.isLoadingOnboarding = false;
      },
      (err) => {
        this.isLoadingOnboarding = false;
        this.errHandle.errorHandling(err);
      }
    );
  }

  private clientName(user: any): string {
    return user?.third_party_info?.name ??
      user?.third_party_info?.third_party_name ??
      user?.business_name ?? '';
  }

  private normalizeRelatedUser(user: any): any {
    if (!user) return null;
    const thirdPartyInfo = user.third_party_info || {};
    return {
      ...user,
      third_party_info: {
        ...thirdPartyInfo,
        name: thirdPartyInfo.name ?? thirdPartyInfo.third_party_name ?? '',
      },
    };
  }

  private hydrateEditForm(details: any, listUser: any): void {
    const user = details || {};
    const fallback = listUser || {};
    const fallbackThirdParty = fallback.third_party_info || {};
    const userThirdParty = user.third_party_info || {};
    const fallbackContact = fallbackThirdParty.contact_details || {};
    const userContact = userThirdParty.contact_details || {};
    const thirdPartyInfo = {
      ...fallbackThirdParty,
      ...userThirdParty,
      name: userThirdParty.name ?? fallbackThirdParty.name,
      third_party_name: userThirdParty.third_party_name ??
        fallbackThirdParty.third_party_name,
      internal_code: userThirdParty.internal_code ??
        fallbackThirdParty.internal_code,
      products: userThirdParty.products ?? fallbackThirdParty.products,
      contact_details: {
        ...fallbackContact,
        ...userContact,
        address_details: {
          ...(fallbackContact.address_details || {}),
          ...(userContact.address_details || {}),
        },
      },
    };
    const merged = {
      ...fallback,
      ...user,
      first_name: user.first_name ?? fallback.first_name,
      last_name: user.last_name ?? fallback.last_name,
      email: user.email ?? fallback.email,
      phone_number: user.phone_number ?? fallback.phone_number,
      supervisor: user.supervisor ?? fallback.supervisor,
      third_party_info: thirdPartyInfo,
    };
    const address = thirdPartyInfo.contact_details?.address_details || {};

    this.addUserForm.patchValue({
      fname: merged.first_name ?? '',
      lname: merged.last_name ?? '',
      email: merged.email ?? '',
      phone: parseUSPhoneNumber(merged.phone_number) ?? '',
      client_name: this.clientName(merged),
      internal_code: thirdPartyInfo.internal_code ?? '',
      send_invitation: !!merged.send_invitation,
      products: thirdPartyInfo.products ?? [],
      created_name: this.normalizeRelatedUser(merged.supervisor),
    });

    this.formAddress.patchValue({
      street_address: address.address
        ? { label: address.address, type: 'Container' }
        : '',
      country: address.country ?? '',
      city: address.city ?? '',
      state: address.state ?? '',
      zip_code: address.zip_code ?? '',
    });
  }

  openAddEditPopup(
    isAddNew: boolean,
    user?: any,
    parent?: ThirdPartyFullObject
  ) {
    if (parent) {
      this.isSubUserForm = true;
      this.addUserForm.addControl('parent_id', new FormControl(null));
      this.addUserForm.addControl(
        'enable_claim_creation_notification',
        new FormControl(false)
      );
      this.addUserForm.addControl(
        'enable_claim_status_update_notification',
        new FormControl(false)
      );
      this.addUserForm.addControl(
        'enable_claim_agent_change_notification',
        new FormControl(false)
      );
      this.parentFilter.options = { filter_by_group: this.getParentGroupId() };
    }
    if (!isAddNew) {
      this.userId = user?.id;
      this.hydrateEditForm(null, user);
      this.isLoadingTheProducts = true;
      this._api
        .getReq(`/users/${user?.id}`)
        .pipe(
          take(1),
          map((res) => res.data)
        )
        .subscribe({
          next: (userDetails) => {
            this.isLoadingTheProducts = false;
            if (!userDetails) {
              return;
            }

            // Detail responses are inconsistent for older clients. Merge them
            // with the list row so an absent nested field cannot blank the form.
            this.hydrateEditForm(userDetails, user);

            const parent = userDetails.parent;
            if (parent) {
              this.addUserForm.patchValue({
                parent_id: this.normalizeRelatedUser(parent),
              });
              this.addUserForm.patchValue({
                enable_claim_creation_notification:
                  !!userDetails.enable_claim_creation_notification,
                enable_claim_status_update_notification:
                  !!userDetails.enable_claim_status_update_notification,
                enable_claim_agent_change_notification:
                  !!userDetails.enable_claim_agent_change_notification,
              });
            }

            this.contactsFormArray.clear();
            const relatedContacts =
              userDetails?.third_party_info?.related_contacts;
            if (relatedContacts?.length) {
              relatedContacts.forEach((contact: any) =>
                this.contactsFormArray.push(
                  this.newContactForm(
                    contact.id,
                    contact.email,
                    parseUSPhoneNumber(contact.phone)!
                  )
                )
              );
            } else {
              this.addContact();
            }

            const selectedProds = userDetails.third_party_info?.products ??
              user?.third_party_info?.products ?? [];
            {
              this.selectedProdIds = selectedProds.map(
                (product: any) => product?.id
              );
              this.allProducts?.forEach((product: any) => {
                this.selectedProdIds?.includes(product.id)
                  ? this.selectedProducts.push(product)
                  : null;
              });
              this.addUserForm.patchValue({
                products: selectedProds,
                created_name: this.normalizeRelatedUser(
                  userDetails.supervisor ?? user?.supervisor
                ),
              });
              this.isLoadingTheProducts = false;
            }
          },
          error: (err) => {
            this.errHandle.errorHandling(err);
            this.isLoadingTheProducts = false;
          },
        });
    } else {
      this.email?.enable();
      if (parent) {
        this.addUserForm.patchValue({
          parent_id: parent,
        });
        this.fname?.setValue('');
        this.lname?.setValue('');
      }
    }
    this.isAddNew = isAddNew;
    this.addEditUserPopup = true;
    if (isAddNew) {
      this.getOnboarding();
    }
    this.getProducts();
    this.selectedProducts = [];
  }

  getProducts() {
    this.isLoadingTheProducts = true;
    this._api
      .getReq(
        `/${API_VERSIONS.PRODUCTS}/products?include_atlantic_products=true`
      )
      .subscribe(
        (res) => {
          const allProducts = res?.data ? res?.data : [];
          this.allProducts = allProducts.map((item: any) => ({
            id: item?.id,
            label: item?.label,
          }));
          if (this.allProducts?.length === 0) {
            this.allProducts = [{ id: 0, label: 'No matching Products' }];
          }
          if (!this.isAddNew) {
            this.allProducts?.forEach((product: any) => {
              this.selectedProdIds?.includes(product.id)
                ? this.selectedProducts.push(product)
                : null;
            });
          }

          this.isLoadingTheProducts = false;
        },
        (err) => {
          this.isLoadingTheProducts = false;
          this.errHandle.errorHandling(err);
        }
      );
  }

  saveUser(): void {
    if (this.addUserForm.invalid) {
      this.addUserForm.markAllAsTouched();
      return;
    }
    this.loadingSubmit = true;
    const payload = this.mapPayload();

    const request$: Observable<ApiResponse> = this.isAddNew
      ? this._api.postReq(`/member/${this.whoEntered.form}`, payload)
      : this._api.putReq(`/member/${this.userId}`, payload);

    request$
      .pipe(
        take(1),
        finalize(() => (this.loadingSubmit = false))
      )
      .subscribe({
        next: (result: ApiResponse) => {
          this.onHide(true);
          this.notificationService.success('Success', result?.message);
          this.addEditUserPopup = false;
          this.addUserForm.reset();
          this.onAddEditDealer.emit(this.isAddNew ? 'add' : 'update');
          if (this.isAddNew) {
            this.clearFormValuesFromLocalStorage();
          }
        },
        error: (error) => this.errHandle.errorHandling(error),
      });
  }

  private mapPayload(): any {
    let requiredForms: any[] = [];
    const formArray = this.addUserForm.get('formArray') as FormArray;

    (formArray.controls as FormGroup[])?.forEach((formGroup: FormGroup) => {
      if (formGroup?.controls['check']?.value) {
        requiredForms.push(formGroup?.controls['onboardIngId']?.value);
      }
    });
    const formValue = this.addUserForm.value;
    let phoneNumber = this.addUserForm.value.phone
      .split(') ')
      .join('')
      .split('-')
      .join('')
      .split('(')
      .join('');
    let payload: any = {
      group: this.whoEntered.form,
      phone_number: phoneNumber ? '+1' + phoneNumber : '',
      business_name: this.client_name?.value,
      email: this.email?.value,
      send_invitation: this.isAddNew ? !!formValue.send_invitation : false,
      // required_forms:required_forms,
    };

    if (this.fname?.value) {
      payload['first_name'] = this.fname?.value;
    }

    if (this.lname?.value) {
      payload['last_name'] = this.lname?.value;
    }

    if (!this.email?.value) {
      delete payload['email'];
    }

    if (this.internal_code?.value) {
      payload['internal_code'] = this.internal_code?.value;
    }

    if (this.whoEntered.from === 'admin') {
      payload['agent_id'] = this.created_name?.value?.id;
    } else if (this.whoEntered.from !== 'admin') {
      payload['agent_id'] = this.userObj?.id;
    }
    if (this.isSubUserForm) {
      payload['parent_id'] = this.parent_id?.value?.id;
      if (this.whoEntered.form === 'Agent') {
        payload['enable_claim_creation_notification'] =
          formValue.enable_claim_creation_notification;
        payload['enable_claim_status_update_notification'] =
          formValue.enable_claim_status_update_notification;
        payload['enable_claim_agent_change_notification'] =
          formValue.enable_claim_agent_change_notification;
      }
    }
    if (this.formAddress.value.street_address) {
      payload['country'] = this.formAddress.value.country;
      payload['state'] = this.formAddress.value.state;
      payload['city'] = this.formAddress.value.city;
      payload['zip_code'] = this.formAddress.value.zip_code;
      payload['address'] = this.formAddress.value.street_address?.label;
    }
    if (this.addUserForm.get('products')?.value?.length) {
      payload.products = this.addUserForm
        .get('products')
        ?.value.map((product: Product) => product.id);
    } else {
      delete payload.products;
    }
    if (!!requiredForms?.length) {
      payload['required_forms'] = requiredForms;
    }
    if (this.contactsFormArray.value.length) {
      const contacts: any[] = [];

      this.contactsFormArray.value.forEach(
        (contact: { id: number | null; email?: string; mobile?: string }) => {
          const { id, email, mobile } = contact;

          if (email) {
            const emailContact: any = { email };
            if (id) {
              emailContact.id = id;
            }
            contacts.push(emailContact);
          }

          if (mobile) {
            let phoneNumber = mobile
              .split(') ')
              .join('')
              .split('-')
              .join('')
              .split('(')
              .join('');
            const mobileContact: any = { mobile: phoneNumber };
            if (id) {
              mobileContact.id = id;
            }
            contacts.push(mobileContact);
          }
        }
      );

      if (contacts.length) {
        payload['contacts'] = contacts;
      }
    }
    const updatedPayload = Object.fromEntries(
      Object.entries(payload).filter(
        ([_, value]) => value !== undefined && value !== null
      )
    );
    return updatedPayload;
  }

  onHide(shouldUpdateList = false) {
    this.addUserForm.patchValue({
      fname: '',
      lname: '',
      email: '',
      created_name: '',
      contract_name: '',
      phone: '',
      client_name: '',
      products: '',
    });
    this.selectedProdIds = [];
    this.formAddress.reset();
    this.resetAllOnboardingForms();
    this.addUserForm.markAsUntouched();
    this.addUserForm.markAsPristine();
    if (shouldUpdateList) {
      this.router.navigate([]);
    }
  }

  resetAllOnboardingForms() {
    const formArray = this.addUserForm.get('formArray') as FormArray;
    formArray.controls?.forEach((formGroup: any, index: number) => {
      formGroup.controls['check'].setValue(false);
    });
  }

  // open confirmation popup in case the user click on cancel or outside the popup
  accepted() {
    this.messageComponent.close();
    // this.addUserForm.reset();
    this.onHide();
    this.addEditUserPopup = false;
    this.addUserForm.reset();
    this.clearFormValuesFromLocalStorage();
  }

  rejected() {
    this.messageComponent.close();
  }

  closeModalOutside(event: any) {
    // if the form not dirty it's not important to show the discard message
    if (this.addUserForm.dirty) {
      this.messageComponent.open();
    } else {
      this.accepted();
    }
  }

  //handle drag and drag sections
  drop(event: CdkDragDrop<string[]>) {
    if (event.previousIndex != event.currentIndex) {
      moveItemInArray(
        this.optionsFormArray.controls,
        event.previousIndex,
        event.currentIndex
      );
      this.isChangeOrders = true;
    }
  }

  get optionsFormArray(): FormArray {
    return this.addUserForm.get('formArray') as FormArray;
  }

  sliceCreatedUser(user: string) {
    // Brokers return Broker without (s)
    return user.slice(0, user?.length - 1);
  }

  suggestions: any = [];
  onQueryChange(e: any) {
    const searchProduct = e?.query;
    let params: any = {
      global_search: searchProduct,
      include_atlantic_products: true,
    };
    // if (searchProduct.trim() === '') {
    //   this.suggestions = [];
    //   return;
    // }
    // if(searchProduct?.length < 3){
    //   this.suggestions = [];
    //   return
    // }
    this._api
      .getReq(`/${API_VERSIONS.PRODUCTS}/products`, { params: params })
      .subscribe(
        (res) => {
          const suggestions = res?.data ? res?.data : [];
          this.suggestions = suggestions.map((item: any) => ({
            id: item?.id,
            label: item?.label,
          }));
          if (this.suggestions?.length === 0) {
            this.suggestions = [{ id: 0, label: 'No matching suggestions' }];
          }
        },
        (err) => {
          this.errHandle.errorHandling(err);
        }
      );
  }
  onSelected() {
    this.suggestions = [];
  }

  private initForm(): void {
    this.addUserForm = new FormGroup({
      fname: new FormControl(null, [
        Validators.minLength(2),
        Validators.pattern(this.validationService.alphaPattern),
      ]),
      lname: new FormControl(null, [Validators.minLength(2)]),
      email: new FormControl(
        '',
        this.whoEntered.form !== 'Dealer Group'
          ? [
              Validators.email,
              Validators.pattern(this.validationService?.emailPattern),
            ]
          : []
      ),
      phone: new FormControl(
        '',
        this.whoEntered.form !== 'Dealer Group'
          ? [
              Validators.required,
              Validators.pattern(this.validationService.validPhoneUS),
            ]
          : []
      ),
      client_name: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
      ]),
      internal_code: new FormControl('', []),
      products: new FormControl('', []),
      formAddress: new FormGroup({
        street_address: new FormControl(
          '',
          this.whoEntered.form !== 'Dealer Group' ? [Validators.required] : []
        ),
        country: new FormControl('', []),
        state: new FormControl('', []),
        city: new FormControl('', []),
        zip_code: new FormControl('', []),
      }),
      contract_name: new FormControl(
        '',
        this.whoEntered.createdUsers ? [] : []
      ),
      created_name: new FormControl(
        '',
        this.whoEntered.from == 'admin' &&
        this.whoEntered.createdUsers &&
        !this.isSubUserForm &&
        this.whoEntered.form !== 'Dealer Group' &&
        this.whoEntered.form.toLowerCase() !== 'agent'
          ? [Validators.required]
          : []
      ),
      send_invitation: new FormControl(false, []),
      formArray: new FormArray([]),
      contacts: new FormArray([]),
    });
  }

  protected readonly Validators = Validators;
  protected readonly InputFieldType = InputFieldType;
}
